import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *列表
 * 
*/

export const docList = () => Http.get(`${baseUrl}/help/docs`)

/**
 *详情
 * @param docsId
 * 
*/

export const docDetail = docsId => Http.get(`${baseUrl}/help/docs/${docsId}`)

